import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.config({
    nullTargetWarn: false,
});

const homepageUspWrapper = document.querySelector('.page-node-type-homepage .usps-wrapper');

if (!lodash.isNil(homepageUspWrapper)) {

    const homepageUspsHeading = homepageUspWrapper.querySelectorAll('.field--name-body')
    const homepageUsps = homepageUspWrapper.querySelectorAll('.field--name-field-usps .field__item')
    const homepageUspsItems = [...homepageUspsHeading, ...homepageUsps];

    homepageUspsItems.forEach((item, index) => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: '.page-node-type-homepage .usps-wrapper',
                start: '10% bottom'
            },
            delay: (index * 0.2) + 0.5,
            opacity: 0,
            y: '15%',
        });
    });
}

const homepageKlantenVertellenBlock = document.querySelectorAll('.page-node-type-homepage .klantenvertellen-block-large');

Array.from(homepageKlantenVertellenBlock).forEach(block => {
    const imageWrapper = block.querySelector('.image-wrapper');

    gsap.from(imageWrapper.querySelector('.image'), {
        scrollTrigger: {
            trigger: block,
            start: 'top bottom',
            scrub: 1
        },
        y: '-10%',
    });
})

const homepageGuaranteeBlock = document.querySelectorAll('.page-node-type-homepage .guarantee-wrapper');

Array.from(homepageGuaranteeBlock).forEach(block => {
    const imageWrapper = block.querySelector('.image-wrapper');

    gsap.from(imageWrapper.querySelector('.image'), {
        scrollTrigger: {
            trigger: block,
            start: 'top bottom',
            scrub: 1
        },
        y: '-10%',
    });
})

const homepageDonationBlock = document.querySelector('.page-node-type-homepage .donation-wrapper');

if (!lodash.isNil(homepageDonationBlock)) {
    gsap.from(homepageDonationBlock.querySelector('.field--name-field-donation-text > .field__item:last-of-type .inner'), {
        scrollTrigger: {
            trigger: homepageDonationBlock,
            start: 'top bottom',
            scrub: 1,
        },
        y: '-25%',
    });
}

const occasionBlockImage = document.querySelectorAll('.block-section-car .image-car .field--name-field-afbeelding-auto img, .view-occasions-overzicht-teaser .image-car img');

gsap.from(occasionBlockImage, {
    scrollTrigger: {
        trigger: occasionBlockImage,
        start: 'center bottom',
    },
    delay: 0.4,
    opacity: 0,
    x: '30%',
    duration: 1.1
});

const latestNews = document.querySelector('.view-laatste-nieuws.view-display-id-block_1');

if (!lodash.isNil(latestNews)) {
    const latestNewsHeading = latestNews.querySelectorAll('.view-header');
    const latestNewsTeasers = latestNews.querySelectorAll('.view-content .views-row');
    const latestNewsItems = [...latestNewsHeading, ...latestNewsTeasers];

    latestNewsItems.forEach((item, index) => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: '.view-laatste-nieuws .view-content',
                start: '10% bottom'
            },
            delay: (index * 0.2) + 0.5,
            opacity: 0,
            y: '15%',
        });
    });
}

const latestNewsPage = document.querySelector('.view-laatste-nieuws.view-display-id-page_1');

if (!lodash.isNil(latestNewsPage)) {
    const latestNewsTeasers = latestNewsPage.querySelectorAll('.view-content .views-row');

    latestNewsTeasers.forEach((item, index) => {
        gsap.from(item, {
            scrollTrigger: {
                trigger: '.view-laatste-nieuws .view-content',
                start: '10% bottom'
            },
            delay: (index * 0.2) + 0.5,
            opacity: 0,
            y: '15%',
        });
    });
}

const regionFooterC2a = document.querySelector('.region-footer-c2a');

if (!lodash.isNil(regionFooterC2a)) {
    gsap.from(regionFooterC2a.querySelector('.background'), {
        scrollTrigger: {
            trigger: regionFooterC2a,
            start: 'top bottom',
            scrub: 1,
        },
        y: '8%',
    });
}

const articleHeader = document.querySelector('.header-article-layout .field--name-field-header-image');

if (!lodash.isNil(articleHeader)) {
    gsap.from(articleHeader.querySelector('img'), {
        scrollTrigger: {
            trigger: articleHeader,
            start: 'top bottom',
            scrub: 1,
        },
        y: '10%',
    });
}

const header = document.querySelector('.header-layout .field--name-field-header-image');

if (!lodash.isNil(header)) {
    gsap.from(header.querySelector('img'), {
        scrollTrigger: {
            trigger: header,
            start: 'top bottom',
            scrub: 1,
        },
        y: '15%',
    });
}

const specialismsHeading = document.querySelectorAll('.view-specialismes .view-header');
const specialismsBlocks = document.querySelectorAll('.view-specialismes .view-content .views-row');
const specialismsItems = [...specialismsHeading, ...specialismsBlocks];

specialismsItems.forEach((item, index) => {
    gsap.from(item, {
        scrollTrigger: {
            trigger: '.block-views-blockspecialismes-block-2',
            start: '10% bottom'
        },
        delay: (index * 0.2) + 0.6,
        opacity: 0,
        y: '15%',
    })
});